import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Card, CardContent, CardHeader, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { getLocatableAddress } from '../../data/TypeHelpers';
import { getImageUrl } from '../../data/aws/s3/UserBlobs';
import { ObjectDetailCard } from '../../v2/components/generic/ObjectView/ObjectDetailCard';
import { MapV4ShimView } from '../geo/MapViewV4';
import NavLink from '../navigation/NavLink';
import { NavSections } from '../navigation/NavSections';
const debug = process.env.REACT_APP_DEBUG && false;
/** @deprecated - The geofence type is kind of deprecated in itself */
export const GeofenceEditor = (props) => {
    const classes = {};
    const { viewObject, transactionFunctions, userFunctions, allowedActions } = props;
    const [imageUrl, setImageUrl] = React.useState('');
    useEffect(() => {
        async function effectUrl() {
            const objectOrString = await getImageUrl(props.viewObject.matchedPrimary);
            if (typeof objectOrString === 'string') {
                const url = objectOrString;
                debug && console.log('Use Effect has url', url);
                setImageUrl(url);
            }
        }
        effectUrl();
    }, [props.viewObject.matchedPrimary]);
    const locatableAddress = getLocatableAddress(viewObject.matchedPrimary);
    const geoImplementingObject = viewObject.matchedPrimary?.points
        ? viewObject.matchedPrimary
        : undefined;
    const mapCardProps = {
        contextObject: viewObject.matchedPrimary,
        position: undefined,
        //polygons: viewObject.matchedPrimary?.points ? {[viewObject.matchedPrimary.sk]: viewObject.matchedPrimary.points } : undefined
    };
    return (_jsxs(Card, { className: classes.root, children: [_jsx(CardHeader, { avatar: _jsx(NavLink, { filter: `${NavSections.THINGVIEW}/${viewObject.matchedPrimary?.type}/${viewObject.matchedPrimary?.id}`, children: _jsx(Avatar, { "aria-label": "recipe", className: classes.avatar, src: imageUrl, children: viewObject.matchedPrimary
                            ? viewObject.matchedPrimary.name
                                ? viewObject.matchedPrimary.name.substr(0, 1).toUpperCase()
                                : `${viewObject.matchedPrimary.type} ?`
                            : '??' }) }), title: viewObject.matchedPrimary?.name, subheader: viewObject.matchedPrimary?.breed }), _jsx(CardContent, { children: viewObject.matchedPrimary && (_jsx("div", { children: _jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { size: 6, children: _jsx(ObjectDetailCard, { matchedPrimary: viewObject.matchedPrimary,
                                    userFunctions,
                                    transactionFunctions,
                                    mostProximateCustomer: undefined,
                                    //editMode: ComponentMode.VIEW, // ADH - I had to guess here so if its wrong feel free to change
                                    allowedActions }) }), _jsx(Grid, { size: 6, children: _jsx(MapV4ShimView, { transactionFunctions,
                                    locatableAddress,
                                    geoImplementingObject,
                                    viewObjects: [viewObject],
                                    ...mapCardProps,
                                    geofences: { [viewObject.matchedPrimary.sk]: viewObject.matchedPrimary } }) })] }) })) })] }));
};
